import { useFetchWrapper } from 'helpers';
import { Role } from 'states';
import { APIS } from '../constants';

export { useRolesService };

const useRolesService = () => {
  const baseUrl = `${process.env.REACT_APP_BASE_API_URL}`;
  const fetchWrapper = useFetchWrapper();

  const createOrUpdateRole = (newRole: Role) => {
    return fetchWrapper.post<Role[]>(new URL(`${baseUrl}${APIS.ROLE.ADD_UPDATE_ROLE}`), newRole);
  };

  const getRoles = () => {
    return fetchWrapper.get<Role[]>(new URL(`${baseUrl}${APIS.ROLE.GET_ALL_ROLES}`));
  };

  const usersRoleMapping = (usersRoleParam: any) => {
    return fetchWrapper.post(new URL(`${baseUrl}${APIS.ROLE.USERS_ROLE_MAPPING}`), usersRoleParam);
  };

  return { createOrUpdateRole, getRoles, usersRoleMapping };
};
